import { ImportAPI } from '../../../api/datamanager/ImportAPI';

export class ImportCommand {
    constructor() {
        this.importApi = new ImportAPI();
    }

    uploadProviderData(data, successCallback, errorCallback) {
        let dataToSend = new FormData();
        dataToSend.append("file", data.file);
        dataToSend.append("replicateOrientationInfo", data.replicateOrientationInfo);
        dataToSend.append("replicatePriorityInfo", data.replicatePriorityInfo);
        dataToSend.append("deducePassings", data.deducePassings);
        dataToSend.append("createHighestPriorityPaths", data.createHighestPriorityPaths);
        dataToSend.append("replicateStopsInfo", data.replicateStopsInfo);
        dataToSend.append("replicateLineColorsInfo", data.replicateLineColorsInfo);
        dataToSend.append("replicateLineRegionsInfo", data.replicateLineRegionsInfo);
        dataToSend.append("replicatePathNotes", data.replicatePathNotes);
        dataToSend.append("replicatePathStopsInfo", data.replicatePathStopsInfo);
        dataToSend.append("replicateTripNotes", data.replicateTripNotes);
        dataToSend.append("replicateMapPointsInfo", data.replicateMapPointsInfo);
        dataToSend.append("type", data.type);
        dataToSend.append("networkEdition", data.networkEdition);  

        const apiResult = this.importApi.uploadProviderData(dataToSend);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(Object.assign(JSON.parse(result), { message: "Dados carregados com sucesso" }));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    async importProviderData(taskId, params, successCallback, errorCallback) {
        let dataToSend = new FormData();
        dataToSend.append("file", params.file);
        dataToSend.append("deducePassings", params.deducePassings);
        dataToSend.append("createHighestPriorityPaths", params.createHighestPriorityPaths);
        dataToSend.append("replicateStopsInfo", params.replicateStopsInfo);
        dataToSend.append("replicateLineColorsInfo", params.replicateLineColorsInfo);
        dataToSend.append("replicateLineRegionsInfo", params.replicateLineRegionsInfo);
        dataToSend.append("replicatePathNotes", params.replicatePathNotes);
        dataToSend.append("replicatePathStopsInfo", params.replicatePathStopsInfo);
        dataToSend.append("replicateTripNotes", params.replicateTripNotes);
        dataToSend.append("replicateMapPointsInfo", params.replicateMapPointsInfo);
        dataToSend.append("type", params.type);
        dataToSend.append("networkEdition", params.networkEdition);

        const apiResult = this.importApi.importProviderData(taskId, dataToSend);
        await apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(Object.assign(JSON.parse(result), { message: "Dados carregados com sucesso" }));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    async completeImportProviderData(taskId, successCallback, errorCallback) {
        const apiResult = this.importApi.completeImportProviderData(taskId);
        await apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(Object.assign(JSON.parse(result), { message: "Dados carregados com sucesso" }));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    matchProviders(task, matches, successCallback, errorCallback) {
        const apiResult = this.importApi.matchProviders(task, matches);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(Object.assign(JSON.parse(result), { message: "Dados carregados com sucesso" }));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}
